import React, { useEffect, useState, useRef } from "react";
import { useReactToPrint } from "react-to-print";
import { useNavigate } from "react-router";
import Header from "./Header";
import Footer from "../Footer";
import fire from "./Firebase";
import "../App.css";

function Samridhi() {
  const [comeexcel, setcomeexcel] = useState([]);
  const [comeexcel2, setcomeexcel2] = useState([]);
  const conponentPDF = useRef();
  useEffect(() => {
    fire.child("excelcerti").on("value", (data) => {
      if (data.val() == null || data.val() == "") alert("Data Fetch");
      else {
        setcomeexcel(data.val());
      }
    });
  }, []);

  useEffect(() => {
    Object.keys(comeexcel).map((data) => {
      setcomeexcel2(comeexcel[data]);
      
    });
  }, [comeexcel]);

  // const generatePDF = useReactToPrint({
  //   // content: () => conponentPDF.current,
  //   // documentTitle: "Userdata",
  //   // onAfterPrint: () => alert("Data saved in PDF"),
  //   console.log(first)
  // });
  const navigate = useNavigate();
  function generatePDF(keys) {
    sessionStorage.setItem("lastname", keys);
    navigate("/try");
  }
  return (
    <div>
      <Header />
      <center>
        <h1>excel Sheat</h1>
      </center>
      {
        (comeexcel2).map((onemore)=>{
            console.log(onemore.Name)
            return(
                <p>{onemore.Name}</p>
            )
        })
      }
    </div>
  );
}

export default Samridhi;
